// extracted by mini-css-extract-plugin
export default {"list":"List_list__0HS5v","dense":"List_dense__c0AqG","listStyle":"List_listStyle__VzMww"};